module.exports = __webpack_public_path__ + "4-85.jpg?d84af1a0f39a02497bc69d17a63ef69e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4-85.jpg
// module id = 166
// module chunks = 0